module.exports = __webpack_public_path__ + "assets/img/mangguoke_519.0086de88.jpg";